import { Button, Col, Form, Input, Row } from "antd";
import { NPSteps } from "../../../../../components";
import { useUpdateAFL } from "../../../../procedure/human-organization/absence-letter/hooks";
import { DateFormat, EmailType, RegExp, Rules } from "../../../../../constants";
import { useMail } from "../../../../../hook";
import { DateHelper, StringHelper } from "../../../../../helper";
import { getSiteUrl } from "../../../../procedure/human-organization/absence-letter/utils";
import { usePermissions } from "../../../../role-control/hooks/use-permissions";

const findEmailDifferencesWithNames = (obj1: any, obj2: any) => {
  const differences: { oldName: string; oldEmail: string; newName: string; newEmail: string }[] = [];

  for (const key in obj1) {
    if (key.startsWith("email") && obj1[key] !== obj2[key]) {
      const nameKey = key.replace("email", "name"); // Find corresponding name key
      differences.push({
        oldName: obj1[nameKey],
        oldEmail: obj1[key],
        newName: obj2[nameKey],
        newEmail: obj2[key],
      });
    }
  }

  return differences;
};

const AFLStepsForm = ({ record }: any) => {
  const {
    eApprovalProcess: { current, status },
    eSteps,
    id,
    eCreatedBy,
    Created,
    eAFLType,
    eDepartment,
  } = record;

  const { updateApplicationForLeave, isLoading } = useUpdateAFL();
  const { havePerUpdateConfigPermAFLs } = usePermissions();

  const isUpdate = havePerUpdateConfigPermAFLs;
  const { sendMailChangeApproval, sendMail } = useMail();
  const [aflType] = StringHelper.verticalBarSplit(eAFLType);
  const siteUrl = getSiteUrl(aflType, eDepartment);

  const handleSendMail = (values: any) => {
    const mappedSteps = eSteps.map((itemArray: any, outerIndex: number) =>
      itemArray.map((item: any, innerIndex: number) => ({
        [`name-${outerIndex}-${innerIndex}`]: item.name,
        [`email-${outerIndex}-${innerIndex}`]: item.email,
      })),
    );

    const mergedObject = mappedSteps.reduce((acc: any, curr: any) => {
      return { ...acc, ...curr[0] };
    }, {});

    const difference = findEmailDifferencesWithNames(mergedObject, values);

    if (difference.length > 0) {
      difference.forEach((e) => {
        sendMailChangeApproval({
          mailTo: { name: e.oldName, email: e.oldEmail },
          approval: { email: e.newEmail, name: e.newName },
          created: {
            byName: StringHelper.verticalBarSplit(eCreatedBy)[1],
            dateTime: DateHelper.formatDateToString(Created, { format: DateFormat.DD_MM_YYYY_HH_MM }),
          },
          eMailType: EmailType.AFLC,
          toPath: `${siteUrl}/${id}`,
        });

        sendMail({
          mailTo: { name: e.newName, email: e.newEmail, action: "duyệt" },
          created: {
            byName: StringHelper.verticalBarSplit(eCreatedBy)[1],
            dateTime: DateHelper.formatDateToString(Created, { format: DateFormat.DD_MM_YYYY_HH_MM }),
          },
          eMailType: EmailType.AFLA,
          toPath: `${siteUrl}/${id}`,
        });
      });
    }
  };

  const handleSubmitForm = (values: any) => {
    const eStepsUpdate = eSteps.map((itemArray: any, outerIndex: number) =>
      itemArray.map((item: any, innerIndex: number) => {
        return {
          ...item,
          name: values[`name-${outerIndex}-${innerIndex}`],
          email: values[`email-${outerIndex}-${innerIndex}`],
        };
      }),
    );

    updateApplicationForLeave({ id: id, body: { eSteps: eStepsUpdate } }, { successText: "Cập nhật thành công" });

    handleSendMail(values);
  };

  return (
    <>
      <NPSteps current={current} status={status} items={eSteps} />
      <Form layout="vertical" onFinish={handleSubmitForm} disabled={!isUpdate}>
        {eSteps.map((itemArray: any, outerIndex: number) =>
          itemArray.map((item: any, innerIndex: number) => (
            <Row key={`${outerIndex}-${innerIndex}`} gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={`Name (${item.title})`}
                  name={`name-${outerIndex}-${innerIndex}`}
                  initialValue={item.name}
                  rules={[Rules.required("Vui lòng nhập tên")]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={`Email (${item.title})`}
                  name={`email-${outerIndex}-${innerIndex}`}
                  initialValue={item.email}
                  rules={[
                    Rules.required("Vui lòng nhập email"),
                    {
                      message: "Vui lòng nhập đúng định dạng: mail@viags.vn",
                      pattern: RegExp.viagsEmail,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          )),
        )}

        <Form.Item className="d-flex flex-row-reverse">
          <Button type="primary" htmlType="submit" loading={isLoading} size="large">
            Cập nhật
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AFLStepsForm;
